

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.44db22bb.js","_app/immutable/chunks/scheduler.2cb4bb00.js","_app/immutable/chunks/index.7d06ba6e.js","_app/immutable/chunks/stores.c3acf62b.js","_app/immutable/chunks/singletons.b043f579.js"];
export const stylesheets = [];
export const fonts = [];
